// Package imports
import { createSlice } from "@reduxjs/toolkit";

// Initial State
const initialState = {
  assetData: null,
  assetLogObj: null,
  currentAttemptData: null,
  currentAttempt: 1,
  duration: 0,
  durationStartTimeStamp: 0,
  durationFlag: false,
  showAnswer: false,
  attempted: false,
  finish: false,
  numberOfAttemptes: 1,
  learnerDefaults: {},
  sessionUid: null,
  trainerContinueTeachingLog: null,
  trainerContinueTeachingClass: null,
  trainerContinueTeachingClassName: null,
  smartCheck: [],
  smartAdvCheck: [],
  attempedAnsLog: null,
  recordingContinueIndex: -1,
  recordingAudioContinueIndex: -1,
  optionWiseAns: [],
  refreshClick: false,
  bingoMin: 0,
  eexamTime: 0,
  timeUp: false,
  aiEnable: true,
  bookLevel: null,
  fromCompletedTab: false,
};

// Redux Slice for Current Asset
const currentAssetSlice = createSlice({
  name: "currentAsset",
  initialState,
  reducers: {
    resetState(state, { payload }) {
      return initialState;
    },
    setAssetData(state, { payload }) {
      return {
        ...state,
        assetData: payload,
      };
    },
    setAssetLogObj(state, { payload }) {
      return {
        ...state,
        assetLogObj: payload,
      };
    },
    setShowAnswer(state, { payload }) {
      return {
        ...state,
        showAnswer: payload,
      };
    },
    setAttempted(state, { payload }) {
      return {
        ...state,
        attempted: payload,
      };
    },
    setFinish(state, { payload }) {
      return {
        ...state,
        finish: payload,
      };
    },
    setNumberOfAttemptes(state, { payload }) {
      return {
        ...state,
        numberOfAttemptes: payload,
      };
    },
    setLearnerDefaults(state, { payload }) {
      return {
        ...state,
        learnerDefaults: payload,
      };
    },
    setAssetLogObjUseranswer(state, { payload }) {
      let newArray;
      if (!payload.evalMode || payload.evalMode == "auto") {
        newArray = [...state.assetLogObj.userAnswer, payload.userAnswer];
      } else {
        newArray = [payload.userAnswer];
      }

      let genericScore =
        +payload.userAnswer.score > +state.assetLogObj.genericScore
          ? +payload.userAnswer.score
          : +state.assetLogObj.genericScore;

      return {
        ...state,
        assetLogObj: {
          ...state.assetLogObj,
          attempts: +payload.attempts,
          userAnswer: newArray,
          duration: +state.assetLogObj.duration + +payload.userAnswer.duration,
          genericScore,
        },
      };
    },
    setCurrentAttemptData(state, { payload }) {
      console.log("&&&&&&&setCurrentAttemptData", payload);
      return {
        ...state,
        currentAttemptData: payload,
      };
    },
    setSmartCheckData(state, { payload }) {
      console.log("&&&&&&&setSmartCheckData", payload);
      return {
        ...state,
        smartCheck: payload,
      };
    },
    setSmartCheckAdvData(state, { payload }) {
      console.log("&&&&&&&setSmartCheckAdvData", payload);
      return {
        ...state,
        smartAdvCheck: payload,
      };
    },
    setCurrentAttempt(state, { payload }) {
      return {
        ...state,
        currentAttempt: payload,
      };
    },
    setSessionUid(state, { payload }) {
      return {
        ...state,
        sessionUid: payload,
      };
    },
    setTrainerContinueTeachingLog(state, { payload }) {
      return {
        ...state,
        trainerContinueTeachingLog: payload,
      };
    },
    setTrainerContinueTeachingClass(state, { payload }) {
      return {
        ...state,
        trainerContinueTeachingClass: payload,
      };
    },
    setTrainerContinueTeachingClassName(state, { payload }) {
      return {
        ...state,
        trainerContinueTeachingClassName: payload,
      };
    },
    resetDuration(state, { payload }) {
      return {
        ...state,
        duration: 0,
        durationStartTimeStamp: 0,
      };
    },
    startDuration(state, { payload }) {
      if (state.durationFlag) {
        let startdateObj = new Date();
        return {
          ...state,
          durationStartTimeStamp: startdateObj.getTime(),
        };
      }
    },
    stopDuration(state, { payload }) {
      if (state.durationFlag) {
        let enddateObj = new Date();
        let endtimestamp = enddateObj.getTime();
        let duration = 0;
        if (state.durationStartTimeStamp != 0) {
          duration =
            +endtimestamp -
            +state.durationStartTimeStamp +
            Number(state.duration);
        }

        return {
          ...state,
          durationStartTimeStamp: 0,
          duration: duration,
        };
      }
    },
    setDurationFlag(state, { payload }) {
      return {
        ...state,
        durationFlag: payload,
      };
    },
    setAttempedAnsLog(state, { payload }) {
      return {
        ...state,
        attempedAnsLog: payload,
      };
    },
    setRecordingContinueIndex(state, { payload }) {
      return {
        ...state,
        recordingContinueIndex: payload,
      };
    },
    setRecordingAudioContinueIndex(state, { payload }) {
      return {
        ...state,
        recordingAudioContinueIndex: payload,
      };
    },
    setOptionWiseAns(state, { payload }) {
      return {
        ...state,
        optionWiseAns: payload,
      };
    },
    setRefreshClick(state, { payload }) {
      return {
        ...state,
        refreshClick: payload,
      };
    },
    setBingoMin(state, { payload }) {
      return {
        ...state,
        bingoMin: payload,
      };
    },
    setEexamTime(state, { payload }) {
      return {
        ...state,
        eexamTime: payload,
      };
    },
    setTimeUp(state, { payload }) {
      return {
        ...state,
        timeUp: payload,
      };
    },
    setAiEnable(state, { payload }) {
      return {
        ...state,
        aiEnable: payload,
      };
    },
    setBookLevel(state, { payload }) {
      return {
        ...state,
        bookLevel: payload,
      };
    },
    setFromCompletedTab(state, { payload }) {
      return {
        ...state,
        fromCompletedTab: payload,
      };
    },
  },
});

export const currentAssetSliceActions = currentAssetSlice.actions;

export default currentAssetSlice;
